import { render, staticRenderFns } from "./CompanyContent.vue?vue&type=template&id=4d2d7fb9&scoped=true&"
import script from "./CompanyContent.vue?vue&type=script&lang=ts&"
export * from "./CompanyContent.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyContent.vue?vue&type=style&index=0&id=4d2d7fb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2d7fb9",
  null
  
)

export default component.exports